import NavDropdown from '../components/NavDropdown'
import LoginNavItemsWrapper from '../components/LoginNavItemsWrapper'
import styles from './index.module.scss'

const ThirdPatyAgentLoggedInNavItems: React.FC = () => (
  <div className={styles.NavDropdownContainer}>
    <NavDropdown navDropdownClass={styles.NavDropdownContainer}>
      {({ resetToggle }) => (
        <LoginNavItemsWrapper
          loginNavItemHelpers={{
            resetToggle,
          }}
        />
      )}
    </NavDropdown>
  </div>
)

export default ThirdPatyAgentLoggedInNavItems
